import { connect, Dispatch } from 'react-redux';
import { UserProfilePage } from './component';
import { AppState } from '../app/state';
import { tenantSelector } from 'pages/settings/selectors';
import { GetUserProfileAction, UpdateUserProfileAction, SetUserProfileErrorMessageAction } from './actions';
import { Guid } from 'types/guid';
import { User } from 'types/user';
import { Action } from 'helpers/action-helpers';

const mapStateToProps = (state: AppState) => {
  return {
    isOnline: state.connectionStatus.isConnected,
    isProcessing: state.userProfile.isProcessing,
    isProcessingPasswordReset: state.userManagement.isProcessing,
    isLoadingProfileInfo: state.userProfile.isLoadingProfileInfo,
    language: tenantSelector(state).language,
    user: state.userProfile.user,
    errorMessage: state.userProfile.errorMessage,
  };
};

function mapDispatchToProps(dispatch: Dispatch<Action>): object {
  return {
    getUserProfile: (userId: Guid) => dispatch(new GetUserProfileAction(userId)),
    updateUserProfile: (userId: Guid, user: User) => dispatch(new UpdateUserProfileAction(userId, user)),
    setUserErrorMessage: (errorMessage: string) => dispatch(new SetUserProfileErrorMessageAction(errorMessage))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfilePage);


// WEBPACK FOOTER //
// ./src/pages/user-profile/index.tsx